import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  bulkUpdating: {
    description: 'bulkUpdateEpics.bulkUpdating',
    defaultMessage: 'Bulk Updating...',
    id: 'zx77EZ',
  },
  updateSuccessful: {
    description: 'bulkUpdateEpics.updateSuccessful',
    defaultMessage: 'Update Successful',
    id: 'K30lX2',
  },
  bulkUpdateFailed: {
    description: 'bulkUpdateEpics.bulkUpdateFailed',
    defaultMessage: 'Update Failed',
    id: '6lenlu',
  },
  bulkUpdateFailedContent: {
    description: 'bulkUpdateEpics.bulkUpdateFailedContent',
    defaultMessage: 'The bulk update request failed. Please try again or contact support.',
    id: 'uOVagR',
  },
  bulkUpdateJobErrorTitle: {
    description: 'bulkUpdateEpics.bulkUpdateJobErrorTitle',
    defaultMessage: 'Bulk Update Error',
    id: 'GxVWAh',
  },
  bulkUpdateJobErrorMessage: {
    description: 'bulkUpdateEpics.bulkUpdateJobErrorMessage',
    defaultMessage: 'Could not perform bulk update at this time. Please try again.',
    id: 'TxLOf9',
  },
});
